export default __webpack_public_path__ + "static/media/hero-image.2d0ef15e.png";